import { type Meta } from '../types/docs';

const META: Meta = {
  description: "An author added an external link to a collection share link's navigation",
  name: 'header_link_added',
};

export default META;
